/**
 * Product card image carousel.
 * Lets shoppers browse a product's photos directly on its card (collections,
 * home page, related/complementary products, wishlist grid) before opening
 * the product page. Uses event delegation on `document`, so it works on any
 * number of cards, including ones rendered dynamically after page load
 * (e.g. by the wishlist page or infinite-scroll style sections).
 */
(function () {
  function getImages(carousel) {
    return Array.prototype.slice.call(carousel.querySelectorAll('.card-carousel__image'));
  }

  function loadImage(img) {
    var dataSrc = img.getAttribute('data-src');
    if (dataSrc) {
      img.setAttribute('src', dataSrc);
      img.removeAttribute('data-src');
    }
  }

  function getActiveIndex(carousel) {
    return parseInt(carousel.getAttribute('data-active-index') || '0', 10);
  }

  function setActive(carousel, index) {
    var images = getImages(carousel);
    if (!images.length) return;

    var total = images.length;
    var newIndex = ((index % total) + total) % total;

    images.forEach(function (img, i) {
      if (i === newIndex) {
        loadImage(img);
        img.classList.add('is-active');
      } else {
        img.classList.remove('is-active');
      }
    });

    var dots = carousel.querySelectorAll('.card-carousel__dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === newIndex);
    });

    carousel.setAttribute('data-active-index', String(newIndex));
  }

  function preload(carousel) {
    if (carousel.getAttribute('data-preloaded') === 'true') return;
    carousel.setAttribute('data-preloaded', 'true');
    getImages(carousel).forEach(loadImage);
  }

  // Preload the rest of a card's images as soon as the shopper shows intent
  // to look at that card (hover / keyboard focus / touch), so switching
  // images afterwards feels instant.
  document.addEventListener(
    'mouseenter',
    function (event) {
      var carousel = event.target.closest && event.target.closest('[data-card-carousel]');
      if (carousel) preload(carousel);
    },
    true
  );

  document.addEventListener('focusin', function (event) {
    var carousel = event.target.closest && event.target.closest('[data-card-carousel]');
    if (carousel) preload(carousel);
  });

  document.addEventListener(
    'touchstart',
    function (event) {
      var carousel = event.target.closest && event.target.closest('[data-card-carousel]');
      if (!carousel) return;
      preload(carousel);
      carousel._cardCarouselTouchStartX = event.touches[0].clientX;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      var carousel = event.target.closest && event.target.closest('[data-card-carousel]');
      if (!carousel || typeof carousel._cardCarouselTouchStartX !== 'number') return;

      var deltaX = event.changedTouches[0].clientX - carousel._cardCarouselTouchStartX;
      carousel._cardCarouselTouchStartX = null;

      if (Math.abs(deltaX) > 30) {
        var direction = deltaX < 0 ? 1 : -1;
        setActive(carousel, getActiveIndex(carousel) + direction);
      }
    },
    { passive: true }
  );

  document.addEventListener('click', function (event) {
    var prevButton = event.target.closest && event.target.closest('.card-carousel__arrow--prev');
    var nextButton = event.target.closest && event.target.closest('.card-carousel__arrow--next');
    var dot = event.target.closest && event.target.closest('.card-carousel__dot');

    if (prevButton || nextButton) {
      var arrowCarousel = (prevButton || nextButton).closest('[data-card-carousel]');
      if (!arrowCarousel) return;
      // Stop this click from bubbling to the card's full-card product link.
      event.preventDefault();
      event.stopPropagation();
      setActive(arrowCarousel, getActiveIndex(arrowCarousel) + (prevButton ? -1 : 1));
      return;
    }

    if (dot) {
      var dotCarousel = dot.closest('[data-card-carousel]');
      if (!dotCarousel) return;
      event.preventDefault();
      event.stopPropagation();
      var index = parseInt(dot.getAttribute('data-index') || '0', 10);
      setActive(dotCarousel, index);
    }
  });
})();
